import { ReactComponent as InfoSvg } from '../../assets/icons/info.svg';

export const InfoIcon: SvgIcon = (props) => {
    return <InfoSvg {...props} />;
};
